<template>
  <Modal
    :show="show"
    class="modal-window"
    :onClose="onClose"
    position="center-center"
  >
    <div class="center-align">
      <div class="desciption">{{message}}</div>
    </div>
  </Modal>
</template>

<script setup>
import Modal from '@/components/ui/Modal';

// Define component name
defineOptions({
  name: 'modal-window'
});

// Props
defineProps({
  show: { type: Boolean, required: true },
  onClose: { type: Function, default: () => {} },
  message: { type: String, default: '' }
});
</script>

<style lang="stylus" scoped>
.modal-window {
  padding: 0 8.333333333333334%;
  @media screen and (max-width: 768px) {
      padding 0 15px;
  }
  & :deep(.modal-content) {
    width: 23.333333333333336%;
    border: none;
    border-radius: 5px;
    @media (max-width: 996px) {
      width: 80%;
    }

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .center-align {
    text-align: center;
  }
  .description {
    margin: 0 0 40px 0;
  }
}

</style>


